import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  bg?: 'white' | 'cream' | 'navy';
}
export function Section({
  children,
  className = '',
  id,
  bg = 'white'
}: SectionProps) {
  const bgColors = {
    white: 'bg-white',
    cream: 'bg-cream',
    navy: 'bg-navy text-white'
  };
  return <section id={id} className={`py-16 md:py-24 w-full ${bgColors[bg]} ${className}`} data-id="element-175">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className="max-w-sales mx-auto px-6" data-id="element-176">
        {children}
      </motion.div>
    </section>;
}